import { publishChannel, subscribeChannel } from './channelUtils';

export function sendLoadingUpdate(state) {

    publishChannel('loading-update', state);

}

export function listenLoading(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'loading-update'
        ) {
            return;
        }

        callback(payload);

    });

}